<template>
  <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
    <van-swipe-item v-for="(item, index) in list" @click="bannerBack(item)" :key="index">
      <template v-if="item.isWechat == 1">
        <div class="imgbox">
          <img class="img" :src="item.src" alt="" />
          <wx-open-launch-weapp
            id="launch-btn"
            class="launch-btn"
            username="gh_f188c3821099"
            @error="handleErrorFn"
            @launch="handleLaunchFn"
          >
            <script type="text/wxtag-template">
              <style>.btn{position: absolute;bottom:0px;right: 0px;left:0;top:0;opacity: 0;z-index:99}</style>
              <button class='btn'></button>
            </script>
          </wx-open-launch-weapp>
        </div>
      </template>
      <template v-else>
        <img class="img" :src="item.src" alt="" />
      </template>
    </van-swipe-item>
  </van-swipe>
</template>
<script>
import { shuffle } from '@/utils/index';
export default {
  props: ['adData'],
  computed: {
    list() {
      let arr = [];
      this.adData.map((item, index) => {
        if (index < this.adData.length - 1) {
          arr.push(item);
        }
      });

      arr = shuffle(arr);
      arr.push(this.adData[this.adData.length - 1]);
      return arr;
    },
  },
  data() {
    return {};
  },
  methods: {
    shuffle,
    handleErrorFn(e) {
      console.log(e);
    },
    handleLaunchFn() {
      console.log(e);
    },
    bannerBack(e) {
      if (e.isWechat == 1) {
        return;
      }
      if (e.url) {
        window.location.href = e.url;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.my-swipe {
  .van-swipe-item {
    color: #fff;
    font-size: 20px;
    min-height: 80px;
    text-align: center;
    background-color: #f8f8f8;
    .imgbox {
      width: 100%;
      position: relative;
    }
  }
  .img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .launch-btn {
    position: absolute; // 绝对定位
    bottom: 0px;
    right: 0px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 999;
  }
}
</style>
